export default __webpack_public_path__ + "static/media/info-card-2.9a5119d1.jpg";